import '../scss/app.scss';
import '../../vendor/power-components/livewire-powergrid/dist/tailwind.css';

import './../../vendor/power-components/livewire-powergrid/dist/powergrid.js';
import flatpickr from 'flatpickr/dist/flatpickr.js';

window.flatpickr = flatpickr;

document.addEventListener('DOMContentLoaded', function() {
    const offCanvas = document.querySelector('.off-canvas-panel');
    const offCanvasOpenBtn = document.getElementById('off-canvas-open');
    const offCanvasCloseBtn = document.getElementById('off-canvas-close');

    const chatPanel = document.querySelector('.chat-panel');
    const chatPanelOpenBtn = document.getElementById('chat-panel-open-btn');
    const chatPanelCloseBtn = document.getElementById('chat-panel-close-btn');

    if (chatPanelOpenBtn) {
        chatPanelOpenBtn.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();

            if (!chatPanel.classList.contains('chat-panel--opened')) {
                chatPanel.classList.add('chat-panel--opened');
            } else {
                chatPanel.classList.remove('chat-panel--opened');
            }
        });

        chatPanelCloseBtn.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();

            if (chatPanel.classList.contains('chat-panel--opened')) {
                chatPanel.classList.remove('chat-panel--opened');
            }
        });
    }

    function openOffCanvasMenu(event) {
        event.preventDefault();
        event.stopPropagation();

        offCanvas.classList.add("off-canvas-panel--opened");
        offCanvasOpenBtn.setAttribute("aria-expanded", "true");
        offCanvasCloseBtn.setAttribute("aria-expanded", "true");
        console.log('opened');

        // Add event listener to close the menu when clicking outside of it
        document.addEventListener("click", closeOffCanvasByClickOut);
    }

    function closeOffCanvasMenu() {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        offCanvas.classList.remove("off-canvas-panel--opened");
        offCanvasOpenBtn.setAttribute("aria-expanded", "false");
        offCanvasCloseBtn.setAttribute("aria-expanded", "false");

        // Remove the event listener for clicking outside of the menu
        document.removeEventListener("click", closeOffCanvasByClickOut);
    }

    function closeOffCanvasByClickOut(event) {
        if (!offCanvas.contains(event.target)) {
            closeOffCanvasMenu(event);
        console.log('closed from closeOffCanvasByClickOut');
        }
    }

    function handleWindowResize() {
        if (window.innerWidth > 812 && offCanvas.classList.contains("off-canvas-panel--opened")) {
            offCanvas.classList.remove("off-canvas-panel--opened");
            offCanvasOpenBtn.setAttribute("aria-expanded", "false");
            offCanvasCloseBtn.setAttribute("aria-expanded", "false");
        }
    }

    if (offCanvasOpenBtn) {
        offCanvasOpenBtn.addEventListener("click", openOffCanvasMenu);
        offCanvasCloseBtn.addEventListener("click", closeOffCanvasMenu);
        window.addEventListener("resize", handleWindowResize);
    }
});